import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

const Loading = (props) => {
  return (
    <React.Fragment>
      <img
        alt="圖檔載入中，請稍候"
        src="/main.png"
        style={{
          position: "relative",
          height: "100%",
        }}
      />
      <div style={{
        position: "absolute",
        top: "40%",
        width: "100%",
        color: "White"
      }}>
        <h3>讀取案件資料中...</h3>
        <CircularProgress value={props.progress} />
      </div>
    </React.Fragment>
  )
}

export default Loading
